import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import cn from 'classnames';
import dibsCss from 'dibs-css';

import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import { type PdpSharedStorefrontLink_seller$key } from './__generated__/PdpSharedStorefrontLink_seller.graphql';

type Props = {
    seller: PdpSharedStorefrontLink_seller$key;
};

const sellerFragment = graphql`
    fragment PdpSharedStorefrontLink_seller on Seller {
        sellerPreferences {
            storefrontUrl
        }
    }
`;

export const PdpSharedStorefrontLink: FC<Props> = ({ seller: sellerRef }) => {
    const seller = useFragment(sellerFragment, sellerRef);
    const storefrontUrl = seller?.sellerPreferences?.storefrontUrl || '';

    return storefrontUrl ? (
        <Link
            className={cn(dibsCss.sassyFontBodyMedium, dibsCss.textLeft)}
            href={`/dealers/${storefrontUrl}/`}
            dataTn="pdp-view-seller-storefront-link"
            target="_blank"
        >
            <FormattedMessage
                id="PdpSharedSellerInformation.viewSellerStorefront"
                defaultMessage="View Seller Storefront"
            />
        </Link>
    ) : null;
};
